<template>
	<v-layout class="basket-presentation">
		<upgrade-deal-to-menu-dialog
			:dialogOpened="showUpgradeDealToMenuDialog"
			:onClose="() => showUpgradeDealToMenuDialog = false"
			:onConfirm="upgradeDealToMenu"
			:header="$t('shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.deals.title')"
			:text="$t('shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.deals.text')"
			:question="`
					${$t('shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.deals.question', {
						upgradeToItemName: upgradeToMenuData && upgradeToMenuData.upgradeToItemName,
						priceDifference: upgradeToMenuData && formatPriceZero(upgradeToMenuData.priceDifference),
					})}
				`"
			:additionalText="$t('shopComponents.gt2.shoppingCart_steps.shoppingCartStepCheckoutInit.deals.additionalText')"
		/>
		<v-flex xs6 class="upsell-presentation-part" :class="{'visibility-hidden': !shouldShowRecommendations}">
			<v-flex>{{ $t("shopComponents.gt3.basketPresentation.deliciousOrder") }}</v-flex>
			<v-flex class="upsell-presentation-title">{{ $t("shopComponents.gt3.basketPresentation.recommended") }}</v-flex>
			<v-flex class="upsell-presentation-description">{{ $t("shopComponents.gt3.basketPresentation.tapToAdd") }}</v-flex>
			<div class="upsell-items" v-if="globalSelectedShop.shopOptions.recommendationEngineEnabledBasket">
				<div class="upsell-rcm-product" v-for="product in recommendedProductsList" :key="product.id">
					<div class="upsell-rcm-image-part" @click="addToBasket(product)">
						<img class="upsell-rcm-product-image" :src="backImg(product)[0]" alt="spinning-wheel-product-image">
						<div class="upsell-rcm-name-price-section">
							<div class="upsell-rcm-product-name">{{ product.name }}</div>
							<div class="upsell-rcm-product-price">{{ formatPriceZero(getRecommendedProductPrice(product)) }}</div>
						</div>
					</div>
				</div>
			</div>
		</v-flex>
		<v-flex xs6 class="cart-part" :class="{'discount-part': showDiscounts && showDiscountPart, 'pay-at-counter-enabled' : isKiosk && featureToggles.postpaidOrdersEnabled}">
			<v-btn primary flat class="btn-color" :ripple="false" name="clear-cart" @click="dialog = true">
				<span class="order-button-text"> {{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.cancelOrder")}} &nbsp&nbsp&nbsp</span>
				<v-icon>clear</v-icon>
			</v-btn>
			<v-flex class="cart-part-title">
				{{ $t("shopComponents.gt3.basketPresentation.almost") }}
				<span class="light-green-text">{{ $t("shopComponents.gt3.basketPresentation.done") }}</span>.
				<br> {{ $t("shopComponents.gt3.basketPresentation.reviewOrder") }}</v-flex>
			<div class="basket-choice favourite">
				<div class="basket-choice-restaurant">
					<div>{{deliveryChoice.title}}</div>&nbsp; - &nbsp;<div>{{$store.getters.globalSelectedShop.shopName}}</div>
				</div>
				<div v-if="!isKiosk" class="edit-favourite-restaurant" @click="goToShopSelection">
					<img :src="getImage('basket-edit-icon.svg')" alt="edit-restaurant">
				</div>
			</div>
			<div class="basket-items" :class="{'has-discount-enabled' : showDiscounts}">
				<order-presentation
					:cartProducts="cartProducts"
					:cartOrderTags="cartOrderTags"
					:isProductConfiguring="isProductConfiguring"
					:productCatalog="productCatalog"
					:vouchersRedeemed="vouchersRedeemed"
					:globalSelectedShop="globalSelectedShop"
					:tenantSettings="tenantSettings"
				/>
			</div>
			<div class="cart-part-actions" :class="{'has-discount-enabled' : showDiscounts}">
				<sunset-points-input
					v-if="featureToggles.enableSunsetPoints"
				/>
				<div class="voucher-part-basket">
					<voucher-input
						v-if="!isAtLeastOneDiscountAppliedToCartSelection && (voucherVisible || isVoucher)"
						:cartProducts="cartProducts"
						:orderLines="orderLines"
						:vouchersRedeemed="vouchersRedeemed"
						:featureToggles="featureToggles"
						:globalSelectedShop="globalSelectedShop"
						:productCatalog="productCatalog"
						:voucherRef="voucherRef"
						@show-keyboard="showKeyboard"
						@hide-keyboard="hideKeyboard"
						:applyVoucherFromModal="applyVoucherFromModal"
						@voucherAction="handleVoucherAction"
					/>
					<v-btn
						v-if="isKiosk && (voucherVisible || isVoucher) && !isAtLeastOneDiscountAppliedToCartSelection"
						@click="showKeyboard"
						class="basket-transparent"
						:class="{'visibility-hidden': !(voucherVisible || isVoucher)}"
						primary
						flat
					>
						{{$t("utilityComponents.voucherInput.addVoucher")}}
					</v-btn>
				</div>
				<div v-if="showDiscounts && !isAtLeastOneDiscountAppliedToCartSelection">
					<v-btn
						@click="showDiscountPart = true"
						class="basket-transparent ready-to-redeem-discount"
						primary
						flat
					>
						{{ $t('utilityComponents.productAsCompensationCRMModule.readyToRedeemDiscounts') }} ({{ availableVouchersData.length }})
					</v-btn>
				</div>
				<div class="basket-total-price">{{ $t("shopComponents.gt3.basketPresentation.total") }} {{formatPriceZero(totalPrice)}}</div>
				<v-btn
					@click="goToCatalogPage()"
					class="basket-transparent"
					primary
					flat
					:class="{'pay-at-counter-enabled' : isKiosk && featureToggles.postpaidOrdersEnabled}"
				>
					{{ $t("shopComponents.gt3.basketPresentation.orderMore") }}
				</v-btn>
				<v-btn
					v-if="isKiosk && featureToggles.postpaidOrdersEnabled"
					class="basket-transparent pay-at-counter"
					primary
					flat
					@click="handlePayAtCounter()"
					:disabled="cartProducts.length === 0 || sendingOrder"
					:loading="sendingOrderPayAtCounter"
				>
					{{ $t("shopComponents.gt3.payAtCounter.payAtCounterButton") }}
				</v-btn>
				<v-btn
					@click="goToCheckout()"
					class="basket-green"
					:disabled="!cartProducts.length"
					data-apm-span="checkout"
					primary
					flat
					data-gtm-go-to-payment="true"
					data-cy="pay"
				>
					{{ $t(`shopComponents.gt3.shoppingCart.shoppingCartBottomStepper.checkout.${channel}`) }}
				</v-btn>
			</div>
			<v-flex v-if="showDiscountPart" class="discount-voucher">
				<v-btn primary flat class="btn-color" :ripple="false" name="clear-cart" @click="showDiscountPart = false">
					<v-icon>chevron_left</v-icon>
					<span class="order-button-text"> {{ $t("shopComponents.defaultGlobalTemplate.shoppingCart_steps.shoppingCartStepConfirm.back") }}</span>
				</v-btn>
				<discount :onClose="() => showDiscountPart = false"/>
			</v-flex>
		</v-flex>
		<v-dialog
			v-model="dialog"
			content-class="cancel-order-modal">
			<v-card>
				<v-card-title>
					<div class="popup-wrapper">
						<v-container>
							<v-flex xs12 class="close-image">
								<img class="delivery-image" :src=deliveryChoice.href.white>
								<div class="popup-title">{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.popupMessage")}}</div>
								<div class="popup-subtitle">{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.popupSubtitle")}} </div>
							</v-flex>
							<v-flex>
								<div class="buttons-wrapper">
									<v-card-actions>
										<v-btn
											class="back-btn"
											@click="dialog = false"
										>
											{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.back")}}
										</v-btn>

										<v-btn
											class="quit-btn"
											@click="clearBasket()"
										>
											{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.interrupt")}}
										</v-btn>
									</v-card-actions>
								</div>
							</v-flex>
						</v-container>
						<div class="close-btn" @click="dialog=false"></div>
					</div>
				</v-card-title>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="isKeyboardShown"
			v-if="isKiosk && isKeyboardShown"
			:content-class="`keyboard-dialog`"
		>
			<v-layout column class="kiosk-modal keyboard-layout">
				<div>
					<v-btn icon class="close-btn" @click="isKeyboardShown = false">
						<img  alt="" class="close-image" src="../../../../../static/tid100/images/icons/x-close.svg"/>
					</v-btn>
					<v-layout class="keyboard-dialog-title">
						{{$t("utilityComponents.voucherInput.insertYourCode")}}
					</v-layout>
					<v-layout class="keyboard-dialog-body">
						<v-text-field
							ref="voucherModalInput"
							type="text"
							class="voucher-modal-input"
							v-model="voucherRef"
							required
						></v-text-field>
						<keyboard-input
							v-if="voucherVisible && isKeyboardShown"
							:get-image="getImage('delete-number-icon.svg')"
							:keyboard-characters="keyboardCharacters"
							:show-additional-buttons="true"
							@insert-number="insertNumber"
							@delete-last-digit="deleteLastDigit"
							@hide-keyboard="hideKeyboard"
							class="keyboard"
						/>
						<v-btn class="green-btn keyboard-dialog-btn" @click="applyVoucher">
							{{$t("utilityComponents.voucherInput.approve")}}
						</v-btn>
						<v-layout class="keyboard-description">
							{{$t("utilityComponents.voucherInput.insertCodeDescription")}}
						</v-layout>
					</v-layout>
				</div>
			</v-layout>
		</v-dialog>
		<mystery-box
			v-if="mysteryBoxProductId"
			:mystery-box-product-id="mysteryBoxProductId"
			:applicable-mystery-box-price-rule="applicableMysteryBoxPriceRule"
			:close-modal="closeMysteryBoxModal"
			@mysteryBoxProductAdded="mysteryBoxProductAdded"
		/>
		<restart-app-dialog
			:modal-component-shown="idleDialog"
			:dialogTime="dialogTime"
			:closeCallback="stayOnPage"
		/>
		<custom-transition
			:msg-to-appear="snackbar.msgToAppear"
			@msg-to-appear="() => { snackbar.msgToAppear = '' }"
			:isActive="snackbar.isActive"
		/>
	</v-layout>
</template>

<script>
import * as Utils from "../../../../libraries/utils";
import {pushGTMInternal} from "../../../../integrations/tracking/gtm/pushGtmEvents";
import {prepareGTMeCommerceData} from "../../../../integrations/tracking/gtm/gtmHelper";
import {pushGTMeCommerceData} from "../../../../integrations/tracking/gtm/pushGTMeCommerceData";
import appConfig from "../../../../appconfig";
import {mapGetters} from "vuex";
import OrderPresentation from "./OrderPresentation-gt3.vue";
import {getProductIdsFromOrderLines} from "../../../../helper/ProductSelectionHelper";
import RecommendationEngineProvider from "../../../../providers/RecommendationEngineProvider";
import {DeliveryMethodsEnum} from "../../../../domains2/libraries/DeliveryMethods";
import * as mutationTypes from "../../../../store/mutation-types";
import {canBePickedUp, getBackImages} from "../../../../libraries/utils";
import {formatPriceZero} from "../../../../domains2/libraries/Utils";
import OrderHelperObject from "../../../../domains2/orders/OrderHelperObject";
import {getProductPriceWithDiscounts} from "../../../../libraries/globalTemplateSpecific/bm100/utils";
import ProductSelection from "../../../../domains2/orders/ProductSelection";
import * as actions from "../../../../store/mutation-types";
import protectOrderFlowMixin from "../../../../mixins/protectOrderFlow.mixin";
import KeyboardInput from "../../../UtilityComponents/KeyboardInput.vue";
import VoucherInput from "../../../UtilityComponents/VoucherInput.vue";
import SunsetPointsInput from "../../../UtilityComponents/SunsetPointsInput.vue";
import mysteryBoxMixin from "../../../../mixins/mysteryBox.mixin";
import MysteryBox from "../../../UtilityComponents/MysteryBox.vue";
import OrderItemCommonMixin from "../../../../mixins/OrderItemCommon.mixin";
import {SET_VOUCHER_VIRTUAL_ORDER_ID} from "../../../../store/mutation-types";
import MysteryBoxProvider from "../../../../providers/MysteryBoxProvider";
import kioskIdleTimeoutMixin from "../../../../mixins/kioskIdleTimeout.mixin";
import RestartAppDialog from "../RestartAppDialog-gt3.vue";
import Discount from "../../gt2/Discount/Discount.vue";
import voucherAwardMixin from "../../../../mixins/voucherReward/voucherAward.mixin";
import productSelectionMixin from "../../../../mixins/productSelection.mixin";
import dealsMixin from "../../../../mixins/deals.mixin";
import pricesMixin from "../../../../mixins/prices.mixin";
import UpgradeDealToMenuDialog from "../../gt2/Dialogs/UpgradeDealToMenuDialog.vue";
import productCatalogMenuMixin from "../../../../mixins/productCatalogMenu.mixin";
import CustomTransition from "../../../UtilityComponents/CustomTransition.vue";
import basketMixin from "../../../../mixins/basket.mixin";

const {Formats: timeBoxFormats, timebox: timeBox} = appConfig.timeBoxImpl;
const tenantConfig = appConfig.tenantConfig;

export default {
	name: "BasketPresentation",
	components: {
		CustomTransition,
		Discount,
		RestartAppDialog,
		MysteryBox,
		SunsetPointsInput,
		VoucherInput,
		KeyboardInput,
		OrderPresentation,
		UpgradeDealToMenuDialog
	},
	props: ["isProductConfiguring", "isVoucher"],
	mixins: [
		protectOrderFlowMixin,
		mysteryBoxMixin,
		OrderItemCommonMixin,
		kioskIdleTimeoutMixin,
		voucherAwardMixin,
		productSelectionMixin,
		pricesMixin,
		dealsMixin,
		productCatalogMenuMixin,
		basketMixin
	],
	data() {
		return {
			dialog: false,
			recommendedProductsList: [],
			receiptLine: null,
			orderLine: null,
			voucherRef: "",
			keyboardCharacters: [
				["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
				["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
				["A", "S", "D", "F", "G", "H", "J", "K", "L", "."],
				["Z", "X", "C", "V", "B", "N", "M"]
			],
			isKeyboardShown: false,
			applyVoucherFromModal: false,
			mysteryBoxProductId: null,
			applicableMysteryBoxPriceRule: null,
			showDiscountPart: false,
			upgradeToMenuData: null,
			showUpgradeDealToMenuDialog: false,
			sendingOrder: false
		};
	},
	async created() {
		if (!this.$store.getters.priceRules || !this.$store.getters.priceRules.length) {
			await this.$store.dispatch(mutationTypes.FETCH_PRICE_RULES);
		}
		if(this.shouldShowRecommendations) {
			this.getRecommendationProducts();
		}
	},
	async mounted() {
		const productSelectionWithMysteryBoxVoucher = (this.selections || []).find(ps => ps.mysteryBoxAppliedVoucherId);
		if(productSelectionWithMysteryBoxVoucher && !this.globalSelectedShop.shopOptions.enableMysteryBoxRandomActOfKindness) {
			this.$store.commit(mutationTypes.REMOVE_VOUCHER_FROM_ORDER, productSelectionWithMysteryBoxVoucher.mysteryBoxAppliedVoucherId);
			this.$store.dispatch(mutationTypes.REMOVE_FROM_CART, productSelectionWithMysteryBoxVoucher.productId);
			this.$store.commit(mutationTypes.SET_MYSTERY_BOX_MODAL_STATE, true);
		}
		if(this.isKiosk) {
			this.resetTimer();
			this.idleTimer();
		}
		if(appConfig.isBM100()) {
			this.pushGTMInternal(
				"SSpageview",
				"Basket presentation",
				this.$route.path,
				"",
				{
					email: (this.$store.getters.personData || {}).email,
					selectedRestaurant: (this.globalSelectedShop || {}).shopName
				}
			);
		}
		await this.getVouchersData();
		if(this.isBM100 && this.$store.getters.selectedDealId) {
			const dealSelection = this.selections.find(s => s.productId === this.$store.getters.selectedDealId);
			if(dealSelection) {
				this.showUpgradeDealToMenuDialog = this.shouldActivateUpgradeToMenu(dealSelection);
			}
		}
	},
	computed: {
		...mapGetters([
			"cartProducts",
			"tenantSpecificData",
			"featureToggles",
			"productCatalog",
			"tenantSettings",
			"globalSelectedShop",
			"cartOrderTags",
			"vouchersRedeemed",
			"orderLines",
			"selections",
			"totalPrice",
			"recommendedProducts",
			"voucherVirtualOrderId",
			"experimentId",
			"applicationUserLoggedIn",
			"cachedPickupRules"
		]),
		showDiscounts() {
			return this.featureToggles.enableDiscountsPage && this.applicationUserLoggedIn;
		},
		voucherVisible() {
			return this.featureToggles.voucherEnabled;
		},
		shouldShowRecommendations() {
			return this.featureToggles.recommendationEngine
				&& this.globalSelectedShop.shopOptions.recommendationEngineEnabledBasket;
		},
		channel() {
			return appConfig.channelAlias();
		},
		deliveryChoice() {
			const self = this;
			const channelFolder = self.channel === "desktopBrowser" ? "desktop" : self.channel;
			const deliveryChoices = [
				{
					id: 0,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.eatIn.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/eat-in-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/eat-in-white.svg`
					}
				},
				{
					id: 1,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.parkingPickup.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/parking-pickup-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/parking-pickup-white.svg`
					}
				},
				{
					id: 2,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.takeOut.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				},
				{
					id: 3,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.delivery.desktopBrowser`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				},
				{
					id: 4,
					title: self.$t(`shopComponents.gt3.shoppingCart_steps.shoppingCartStepDeliveryMethod.shoppingCartStepBoothNumber.driveThrough`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				},
				{
					id: 5,
					title: self.$t(`common.deliveryMethods.DRIVE_THROUGH`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				}
			];
			return deliveryChoices.find(item => item.id === self.tenantSpecificData.deliveryChoice);
		},
		recommendedProductPrices() {
			const self = this;
			return getProductPriceWithDiscounts(
				this.recommendedProductsList,
				self.productSelectionsFromAllProducts(this.recommendedProductsList),
				self.productCatalog
			);
		},
		receiptLinesOptions() {
			if(!this.featureToggles.useGermanyPricePresentation) {
				return {};
			}

			return { hideEachDescriptionLine: true };
		},
		receiptLines() {
			return OrderHelperObject.mapToReceiptLines(this.orderLines, this.$i18n, this.receiptLinesOptions);
		},
		staticAwsPath() {
			return Utils.getAwsStaticPath();
		},
		shouldRouteToTableServing() {
			const eatInChosen = this.tenantSpecificData.deliveryChoice === DeliveryMethodsEnum.EAT_IN;
			const takeAwayChosen = this.tenantSpecificData.deliveryChoice === DeliveryMethodsEnum.TAKE_OUT;
			return (
				tenantConfig.tableServing &&
				this.globalSelectedShop.shopOptions.tableServing &&
				eatInChosen
			) || (
				this.channel === "kiosk" &&
				this.globalSelectedShop.shopOptions.enableBeeperDeviceFeature &&
				takeAwayChosen
			);
		}
	},
	methods: {
		formatPriceZero,
		pushGTMInternal : pushGTMInternal,
		async closeMysteryBoxModal() {
			if(this.voucherVirtualOrderId) {
				await MysteryBoxProvider.changeStatusMysteryBox(this.voucherVirtualOrderId);
				this.$store.commit(SET_VOUCHER_VIRTUAL_ORDER_ID);
			}
			this.$store.commit(mutationTypes.SET_MYSTERY_BOX_MODAL_STATE);
			this.mysteryBoxProductId = null;
			await this.goToCheckout();
		},
		mysteryBoxProductAdded() {
			this.goToCheckout();
		},
		async setPickupData() {
			const self = this;
			await self.$store.dispatch(mutationTypes.CART_SET_PICKUP_DATA, {
				pickupDate: timeBox.now().format(timeBoxFormats.YYYY_MM_DD).exec(),
				pickupTime: "ASAP",
				submitted: true
			});
			await self.$store.commit(mutationTypes.SET_ASAP_PICKUP, true);
		},
		async sendOrder() {
			const self = this;
			self.sendingOrder = true;

			const baseUrl = window.location.origin;
			const urlAccept = `${baseUrl}/payment/accept`;
			const urlCancel = `${baseUrl}/payment/cancel`;

			self.$store.dispatch(mutationTypes.CART_INITIALIZE_PAYMENT, {
				urlAccept: urlAccept,
				urlCancel: urlCancel
			}).then(async data => {
				const zeroPaymentPath = `/payment/zero?orderNumber=${data.orderNumber}`;
				if (data.payment.paymentType === "zeroPayment") {
					self.sendingOrder = false;
					self.$router.push(zeroPaymentPath);
				} else {
					self.sendingOrder = false;
					if (self.featureToggles.verticalKioskPayment) {
						await self.$router.push("/checkout");
					} else {
						window.location.replace(data.payment.redirectUrl);
					}
				}
			}).catch((err) => {
				const errorName = err && err.response && err.response.data && err.response.data.errorName;
				if(errorName === "GiveawayCampaignMaxUsageExceeded") {
					self.$store.dispatch("ADD_GLOBAL_ERROR", {friendlyMessage: this.$t("knownErrors.giveawayCampaignMaxUsageExceeded")});
					return;
				}
				self.sendingOrder = false;
				throw err;
			});
		},
		goToHomePage() {
			this.$router.push("/");
		},
		applyVoucher() {
			this.isKeyboardShown = false;
			this.applyVoucherFromModal = true;
		},
		hideKeyboard() {
			this.isKeyboardShown = false;
			this.voucherRef = "";
		},
		deleteLastDigit() {
			if(this.voucherRef.length === 1) {
				this.voucherRef = "";
			} else {
				this.voucherRef = this.voucherRef.toString().slice(0, -1);
			}
		},
		insertNumber(number) {
			this.voucherRef = this.voucherRef.toString().concat(number.toString());
		},
		goToCatalogPage() {
			const firstCategoryId = Utils.getCategoriesByShopId(this.globalSelectedShop.id, this.productCatalog)[0].extId;
			this.$router.push(`/category/${firstCategoryId}`);
		},
		clearBasket() {
			const self = this;
			this.$store.commit(actions.FCM_TOKEN);
			self.$store.dispatch(actions.CART_EMPTY_ALL).then(()=>{
				self.$router.push(tenantConfig.shopHomepage);
			});
		},
		async getRecommendationProducts() {
			this.recommendedProductsList = await this.getRCMProducts();
		},
		getRecommendedProductPrice(product) {
			if(this.recommendedProductPrices[product.id]) {
				return this.recommendedProductPrices[product.id].discountPrice
					? this.recommendedProductPrices[product.id].discountPrice
					: this.recommendedProductPrices[product.id].basePrice;
			}
			return product.price;
		},
		showKeyboard() {
			this.isKeyboardShown = true;
			this.applyVoucherFromModal = false;
			setTimeout(() => {
				const voucherInput = this.$refs.voucherModalInput;
				if(voucherInput) {
					voucherInput.focus();
				}
			}, 0);
		},
		goToShopSelection() {
			this.$router.push("/shop-selection");
		},
		getImage(imageName) {
			return Utils.getMiscImageUrl(imageName);
		},
		backImg(product) {
			return getBackImages(product, this.isKiosk);
		},
		async getRCMProducts() {
			const productToRcm = getProductIdsFromOrderLines(this.orderLines).map(id => {
				try {
					const product = this.productCatalog.getProduct(id);
					return {
						itemNumber: product.id,
						name: product.name
					};
				} catch (e) {
					// product is not available, should be ignored
					return false;
				}
			}).filter(Boolean);

			const {recommendations, buffer, experimentId} = await RecommendationEngineProvider.getRecommendations({
				deliveryMethod: Object.keys(DeliveryMethodsEnum)
					.find(key => DeliveryMethodsEnum[key] === this.tenantSpecificData.deliveryChoice),
				products: productToRcm,
				shopName: this.globalSelectedShop.shopNameAlias,
				channel: appConfig.channelAlias(),
				experimentType: "Basket",
				forceExperimentId: this.experimentId && +this.experimentId ? this.experimentId : null // for case "0"
			}, appConfig.tenantId);
			if(!this.experimentId) {
				this.$store.commit(mutationTypes.SET_EXPERIMENT_ID, experimentId);
			}
			const rawRecommendationsWithBuffer = [
				...(recommendations ? recommendations : []),
				...(buffer ? buffer : [])
			];
			const filteredRecommendedProducts = rawRecommendationsWithBuffer.map(item => {
				// returned products could not be available in Bifrost
				// these should be skipped
				try {
					const product = this.productCatalog.getProduct(item.itemNumber);
					const isProductAvailable = canBePickedUp(
						product,
						this.productCatalog,
						this.$store.getters.cachedPickupRules,
						this.globalSelectedShop.id
					);
					return isProductAvailable ? product : undefined;
				} catch (e) {
					return undefined;
				}
			})
				.filter((product)=> {
					if(!product) {
						return false;
					}
					if(product.options.deliveryMethodIndex) {
						if(!product.options.deliveryMethodIndex.includes(this.tenantSpecificData.deliveryChoice)) {
							return false;
						}
					}
					const categoriesOfProduct = this.productCatalog.getAllCategoriesOfProduct(product.id);
					const isProductCategoriesContainSelectedShop = categoriesOfProduct.some(
						(category) => Array.isArray(category.isSpecificForShops) && category.isSpecificForShops.includes(this.globalSelectedShop.id));
					const isProductSupportedByActiveChannel = !categoriesOfProduct.length || categoriesOfProduct.filter(category => !category.channels || category.channels.includes(appConfig.channelAlias())).length;
					if(isProductSupportedByActiveChannel && isProductCategoriesContainSelectedShop) {
						return product;
					}
					return false;
				});
			this.$store.commit(mutationTypes.SET_RECOMMENDED_PRODUCTS, filteredRecommendedProducts.map((p) => {
				const recommendedProduct = rawRecommendationsWithBuffer.find(r => r.itemNumber === p.id);
				return {
					itemNumber: recommendedProduct.itemNumber,
					type: recommendedProduct.type,
					trackingCode: recommendedProduct.trackingCode
				};
			})
			);
			return (filteredRecommendedProducts || []).slice(0, (this.tenantSettings.maxRecommendedProducts || 6));
		},
		productSelectionsFromAllProducts(products) {
			return products.map(product => {
				const productSelection = ProductSelection.createFromProduct(product);
				productSelection.quantity = 1;
				return productSelection;
			});
		},
		async goToCheckout() {
			const data = prepareGTMeCommerceData();
			pushGTMeCommerceData({
				eventName: "begin_checkout",
				products: data.items,
				value: data.value
			});
			if(await this.getMysteryBoxProduct()) {
				return;
			}
			const self = this;
			if (appConfig.channelAlias() === "desktopBrowser") {
				this.pushGTMInternal("Checkout", "visit", "Init");
				self.$router.push("/checkout");
			} else {
				self.sendingOrder = true;
				await self.setPickupData();
				if (self.getPaymentFlowType === "web") {
					if (self.featureToggles.verticalKioskBasket && self.styleVariant === "a" && self.preCheckout) {
						self.$router.push({ name: "pre-checkout" });
					} else
					if (this.shouldRouteToTableServing) {
						self.$router.push("/table-serving");
					} else {
						await self.sendOrder();
					}
				} else {
					if (this.shouldRouteToTableServing) {
						self.$router.push("/table-serving");
					} else {
						self.$router.push("/checkout");
					}
				}
			}
			if(this.featureToggles.enableRcmProductBadges && this.$store.getters.rcmProductBadgesFeedbackData.recommendations.length) {
				RecommendationEngineProvider.sendFeedbackBadges(
					{
						recommendations: this.$store.getters.rcmProductBadgesFeedbackData.recommendations,
						picks: this.$store.getters.rcmProductBadgesFeedbackData.picks,
						experimentId: `${this.$store.getters.rcmProductBadgesFeedbackData.experimentId}`,
						channel: this.channel,
						shopName: this.globalSelectedShop.shopNameAlias
					},
					appConfig.tenantId
				);
				this.$store.commit(mutationTypes.SET_RCM_PRODUCT_BADGES_PICKS);
			}
		}
	},
	watch: {
		"$store.getters.cartProducts.length": async function(val, oldVal) {
			if(val && val !== oldVal && this.shouldShowRecommendations && val > 0) {
				this.recommendedProductsList = await this.getRCMProducts();
			}
			if(val === 0) {
				this.$store.commit(mutationTypes.SET_SELECTED_DEAL_ID);
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
		clearTimeout(this.time);
	}
};
</script>

<style scoped lang="scss">
.basket-presentation {
	width: 100%;
	height: 100vh;
	color: #FFFFFF;
	position: relative;
	z-index: 2;
	background-color: #000000;
	padding: 50px 200px;
	overflow: hidden;
	.logo-link {
		position: absolute;
		top: 10px;
		left: 10px;
		img {
			height: 60px;
		}
	}
	.upsell-presentation-part {
		.upsell-presentation-title {
			font-size: 40px;
			font-weight: bold;
			line-height: 1;
			margin: 10px 0;
		}
		.upsell-presentation-description {
			font-size: 20px;
		}
		.upsell-items {
			height: calc(100vh - 255px);
			margin-top: 30px;
			display: flex;
			flex-wrap: wrap;
			gap: 25px;
			overflow: auto;
			background-color: black;
			max-width: 550px;
			align-items: center;
			.upsell-rcm-product {
				display: flex;
				width: 254px;
				height: 254px;
				cursor: pointer;
			}
			.upsell-rcm-image-part {
				position: relative;
				border: 2px solid #26282C;
				img {
					width: 250px;
					height: 100%;
				}
			}
			.upsell-rcm-name-price-section {
				position: absolute;
				bottom: 0;
				display: flex;
				justify-content: space-between;
				width: 100%;
				font-size: 16px;
				font-weight: bold;
				padding: 0 10px 10px;
				background: linear-gradient(180deg, transparent 30%, #000 88%);
				height: 70%;
				align-items: flex-end;
				.upsell-rcm-product-price {
					margin-left: 5px;
				}
			}
		}
	}
	.cart-part {
		&:has(.sunset-points) {
			.basket-items {
				height: calc(100vh - 525px);
			}
		}
		.btn-color {
			color: #B3B3B3;
			padding: 0;
			margin: 0;
			text-transform: none;
			height: 21px;
			vertical-align: top;
		}
		.cart-part-title {
			font-size: 40px;
			font-weight: bold;
			line-height: 1;
			margin: 10px 0 30px 0;
		}
		.basket-choice {
			background-color: #FFFFFF;
			border: 1px solid #e9e9e9;
			color: #000000;
			font-weight: bold;
			font-size: 16px !important;
			line-height: 22px;
			display: flex;
			justify-content: space-between;
			padding: 10px;
			margin-top: 10px;
		}
		.basket-choice-restaurant {
			display: flex;
			align-items: center;
			line-height: 32px;
		}
		.edit-favourite-restaurant {
			width: 32px;
			height: 32px;
			background-color: #eaeaea;
			border-radius: 3px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-left: 15px;
			cursor: pointer;
		}
		.basket-items {
			height: calc(100vh - 470px);
			overflow: auto;
			margin-top: 15px;
			&.has-discount-enabled {
				height: calc(100vh - 590px);
			}
			div {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				margin-right: 7px;
				/deep/ .v-card {
					width: 49%;
					margin-bottom: 15px;
					min-width: 49%;
				}
			}
			/deep/ .product-price-container {
				margin-left: 10px;
			}
			/deep/ .order-discount-card {
				width: 49%;
				margin-bottom: 15px;
				min-width: 49%;
				.v-card {
					width: 100%;
					min-width: 100%;
				}
			}
		}
		.cart-part-actions {
			&.has-discount-enabled {
				.voucher-part-basket {
					width: 40%;
				}
				.basket-total-price {
					width: 100%;
				}
			}
		}
		&.discount-part {
			position: relative;
			.discount-voucher {
				position: absolute;
				top: 0;
				width: 101%;
				height: 100%;
				background-color: #000000;
				margin-left: -1px;
				min-width: 101%;
			}
		}
		&.pay-at-counter-enabled {
			&:has(.sunset-points) {
				.basket-items {
					height: calc(100vh - 600px);
				}
				.sunset-points {
					order: -1;
				}
			}
			.basket-items {
				&.has-discount-enabled {
					height: calc(100vh - 667px);
				}
			}
			.cart-part-actions {
				.voucher-part-basket {
					.basket-transparent {
						width: auto !important;
						padding-left: 0;
						border: 0;
						/deep/ .v-btn__content {
							color: #218C74;
						}
					}
				}
				.basket-total-price {
					height: 60px;
					align-items: center;
				}
			}
			.basket-items {
				height: calc(100vh - 547px);
			}
		}
	}
	.cart-part-actions {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-end;
		justify-content: space-between;
		position: relative;
		box-shadow: 0px -7px 5px 0px rgba(0, 0, 0, 0.4);
		.voucher-part-basket {
			width: 49%;
			height: 60px;
			margin-top: 15px;
			.basket-transparent {
				width: 100% !important;
				margin: 0;
			}
			/deep/ .voucher-header {
				margin-top: 0;
			}

			/deep/ .voucher-body .voucher-style {
				background-color: #1A1B1E;
				border-color: #454545;
				&.v-text-field .v-input__control .v-input__slot input {
					color: #FFFFFF;
				}
			}
			/deep/ .v-btn.apply-btn {
				background-color: #D8D8D8 !important;
				.v-btn__content {
					height: 30px !important;
					font-size: 15px;
					line-height: 1;
				}
			}
			/deep/ .voucher-message {
				width: 300px;
				bottom: 110px;
				right: 0;
				left: unset;
			}
		}
		.v-btn {
			height: 60px;
			border-radius: 3px !important;
			margin: 15px 0 0;
			width: 49% !important;
			/deep/ .v-btn__content {
				font-size: 22px;
				font-weight: bold;
				text-transform: none;
			}
		}
		.basket-green {
			background-color: #218C74 !important;
			border: 2px solid #218C74;
			color: #FFFFFF;
		}
		.basket-transparent {
			border: 2px solid #FFFFFF;
			color: #FFFFFF;
			&.pay-at-counter-enabled {
				order: -1;
				width: 100% !important;
			}
		}
		.basket-voucher {
			background-color: #a6a6a6;
			border: 2px solid #a6a6a6;
			color: #FFFFFF;
			margin: 0;
			width: 100%;
		}
		.basket-total-price {
			display: flex;
			justify-content: flex-end;
			width: 49%;
			margin-top: 15px;
			font-size: 20px;
		}
		.sunset-points {
			position: unset;
			width: 100%;
			margin: 10px 0 0;
			color: #000000;
			z-index: unset;
		}
		.ready-to-redeem-discount {
			width: 100% !important;
		}
	}
}
@media screen and (max-width: 1440px) {
	.basket-presentation {
		padding: 50px 100px;
	}
}
.v-card__title{
	padding: 0;
	background-color: #000000;
	.container{
		width: 722px;
		height: 423px;
		border-radius: 5px;
		box-shadow: 0 0 50px 20px rgba(72, 72, 72, 0.23);
		border: solid 3px #26282c;
		background-color: #000000;
		color: #FFFFFF;
		padding: 0;
		.v-card__actions{
			justify-content: center;
			padding-top: 40px;
			.v-btn{
				width: 220px !important;
				height: 50px;
			}
			.back-btn{
				border-radius: 3px;
				border: solid 2px #ffffff;
				font-family: Dispatch-Bold;
				font-size: 22px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				background-color: transparent;
			}
			.quit-btn{
				border-radius: 3px;
				border: solid 2px #ffd800;
				background-color: #ffd800;
				font-family: Dispatch-Bold;
				font-size: 22px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #000000;
				margin-left: 16px;
			}
		}
		.close-image{
			margin-top: 60px;
			text-align: center;
			justify-content: center;
			.delivery-image{
				width: 112px;
				height: 103px;
			}
			.popup-title{
				font-family: Dispatch;
				font-size: 24px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				text-transform: uppercase;
				margin-top: 21px;
				margin-bottom: 16px;
			}
			.popup-subtitle{
				font-family: Dispatch;
				font-size: 18px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				margin: auto;
				padding: 0 15px;
			}
		}
	}
}
.v-dialog.keyboard-dialog {
	.keyboard-layout {
		background-image: none;
		margin-top: 50px;

		.close-btn {
			width: 80px;
			height: 80px;
			border-color: #FFFFFF;
			top: 132px !important;
			right: -10px;
			z-index: 1;
		}
	}

	.keyboard-dialog-title {
		display: flex;
		justify-content: center;
		font-size: 40px;
		padding-bottom: 30px;
	}

	.voucher-modal-input {
		padding: 0;
		margin-bottom: 4px;
		caret-color: #FFFFFF !important;

		/deep/ .v-input__slot {
			//background-color: #171618;
			background-color: #404040;
			height: 70px;
			margin-bottom: 0;

			input {
				max-height: 60px;
				height: 60px;
				font-size: 40px;
				text-align: center;
				color: white;
			}

			&:after {
				border-color: #171618;
			}
		}

		/deep/ .v-text-field__details {
			display: none;
		}

	}

	.keyboard-dialog-body {
		display: flex;
		flex-direction: column;
	}

	.keyboard-dialog-btn {
		height: 70px;
		font-size: 28px;
		text-transform: none;
		margin-top: 4px;
	}

	.keyboard-description {
		justify-content: center;
		padding-top: 30px;
		font-size: 16px;
	}
}

</style>
